module.exports = __webpack_public_path__ + "static/media/kitchenCleaning.da354435.png";